import { localStorageService } from 'src/services/local-storage.service';
export const poliGetUserIDFromLocalStorage = () => {
  const { user } = JSON.parse(window.localStorage.getItem('poli_access'));
  return user.id;
};

const poliAuthTokenGet = () => {
  const { token } = JSON.parse(window.localStorage.getItem('poli_access'));

  const loginInfo = localStorageService.getLocalStorageItem({
    key: 'user_token_login_info',
  })?.legacy_token;

  return token || loginInfo || null;
};

export default poliAuthTokenGet;
